import { render } from "./ModelPage.vue?vue&type=template&id=54762550&scoped=true"
import script from "./ModelPage.vue?vue&type=script&lang=js"
export * from "./ModelPage.vue?vue&type=script&lang=js"

import "./ModelPage.vue?vue&type=style&index=0&id=54762550&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54762550"]])

export default __exports__